{ "imageTag": "20261103055522_3caf047", "buildUri": "vstfs:///Build/Build/103677", "buildId": "103677", "sourceCommit": "3caf047d9e8cd18a942a56849a338c2458507eb2", "sourceBranch": "main", "releaseDate": "2026-11-03T05:58:44Z" }
